/**
 * 图片 CDN 相关常量。
 *
 * 为什么单独一个文件、而不是并进 constant/index.js：
 * index.js 里有 `export { DEFAULT_AVATAR_URI } from '@/utils/image'`，
 * 而 utils/image.js 需要用到下面的 IMG_CDN_URL —— 放一起就是
 * constant/index → utils/image → constant/index 的循环依赖。
 * 这个文件不 import 任何东西，谁都能安全地引它。
 *
 * 三端一致性：域名同时出现在
 *   - 服务端 com.shiyi.common.CdnConstants.CDN_ORIGIN
 *   - App 端 pp-front-uniapp/common/config.js 的 IMG_CDN_URL
 *   - 这里
 * 换域名要三处一起改。
 */

/**
 * 图片 CDN 根地址（不带结尾斜杠）。
 * pic.ylinhua.com CNAME 到腾讯云 CDN，源站是 COS + 数据万象，支持 imageMogr2 处理参数。
 *
 * 必须是 https：图片地址会被写进数据库、被 App 端复用，
 * 而 iOS 的 ATS 默认拦截明文 HTTP 请求。
 */
export const IMG_CDN_URL = 'https://pic.ylinhua.com'

/** CDN 主机名（不含协议），用于判断某个地址是否是自家 CDN */
export const IMG_CDN_HOST = IMG_CDN_URL.replace(/^https?:\/\//, '').replace(/\/+$/, '')

/**
 * 把 COS 对象 key 拼成完整访问地址。
 * @param {String} objectKey 如 systemPic/bg.png，开头带不带斜杠都行
 * @returns {String}
 */
export function cdnUrl (objectKey) {
  if (!objectKey) return IMG_CDN_URL
  const key = String(objectKey).trim()
  return key.startsWith('/') ? IMG_CDN_URL + key : `${IMG_CDN_URL}/${key}`
}

/** 用户主页头部背景的兜底图（与 App 端 DEFAULT_USER_COVER 是同一张） */
export const DEFAULT_USER_COVER = cdnUrl('systemPic/bg.png')

/** 站点 Logo（144x144，移动端引导条、App 下载页共用） */
export const SITE_LOGO_144 = cdnUrl('systemPic/144x144.png')

/**
 * 被内容审核屏蔽的图片占位图的 COS key。聊天图片被内容审核冻结后，服务端下发时把它的地址换成这个
 * （服务端 CdnConstants.BLOCKED_IMAGE_KEY、App 端 utils/imageUrl.js 的同名常量，三处一起改）。
 * 本端认出它就画内联占位图（见 utils/image.js 的 isBlockedImageUrl），不去请求 CDN。
 */
export const BLOCKED_IMAGE_KEY = 'systemPic/image_blocked.png'
